// Modo de posición REAL de la cuenta elegida en el formulario de bot
// PRIVADO: solo lectura + enlace a la edición de la cuenta (el cambio afecta
// a TODOS los bots de la cuenta; el formulario es contexto de UN bot).
// WP-wizard-exchange-modos (docs/specs/Spec_Wizard_Exchange_Modos.md §2.2.3).
// Fail-soft: exchange sin este concepto (BingX) o lectura fallida -> nada.
import { exchangeAccountsService } from '@/services/exchangeAccounts'
import { usePositionMode } from '@/hooks/usePositionMode'
import { wizardPositionModeText } from '@/utils/positionModeCopy'

const fetchPositionMode = exchangeAccountsService.getPositionMode

export default function AccountPositionModeNotice({ accountId, onEditAccount }) {
  const { status, mode } = usePositionMode(accountId, fetchPositionMode)
  if (status !== 'ok') return null
  return (
    <p className="text-xs text-slate-500 dark:text-gray-400 mt-1.5" data-testid="pm-notice">
      {wizardPositionModeText(mode)}
      {onEditAccount && (
        <>
          {' '}
          <button type="button" onClick={onEditAccount} className="text-blue-600 dark:text-blue-400 hover:underline">
            Editar la cuenta →
          </button>
        </>
      )}
    </p>
  )
}
